/**
 * Pure helpers for resolving map checkpoint data from a campaign vs. a fallback.
 * Extracted for testability — CampaignRelayMap delegates to these.
 */

/**
 * Returns the campaign's own checkpoints when non-empty, otherwise the fallback list.
 * @param {object|null} campaign - normalized campaign object
 * @param {Array} fallback - default checkpoint array (e.g. demoCheckpoints)
 */
export function resolveCheckpoints(campaign, fallback) {
  if (Array.isArray(campaign?.mapCheckpoints) && campaign.mapCheckpoints.length > 0) {
    return campaign.mapCheckpoints;
  }
  return fallback;
}

/**
 * Derives the medal list from campaign checkpoints' medalName field.
 * Falls back to the provided list when the campaign has no checkpoints.
 * @param {object|null} campaign - normalized campaign object
 * @param {Array} fallback - default medal array (e.g. demoMedals)
 */
export function resolveMedals(campaign, fallback) {
  if (Array.isArray(campaign?.mapCheckpoints) && campaign.mapCheckpoints.length > 0) {
    return campaign.mapCheckpoints
      .filter((cp) => cp.medalName)
      .map((cp) => ({ id: cp.id, name: cp.medalName, earned: false }));
  }
  return fallback;
}

/**
 * Builds a route config from the campaign's mapConfig, filling gaps from a default route.
 * @param {object|null} campaign - normalized campaign object
 * @param {{ startLocation: string, endLocation: string }} defaultRoute
 */
export function resolveRoute(campaign, defaultRoute) {
  const cfg = campaign?.mapConfig || {};
  return {
    startLocation: cfg.startLocation || defaultRoute.startLocation,
    endLocation:   cfg.endLocation   || defaultRoute.endLocation,
  };
}
